import type { ButtonThemePalette } from '../Button.types';
import { radialEffect } from '../animations/radialEffect';

export const outlined = (
  { button }: ButtonThemePalette,
  isFocused = false,
): string => `
  background-color: ${
    isFocused ? button.text.outline.hover : button.background.outline.base
  };
  border: solid 1px ${button.border.outline.base};
  color: ${button.text.outline.base};

  &:hover,
  &:focus {
    background-color: ${button.background.outline.hover};
    border: solid 1px ${button.border.outline.hover};
    color: ${button.text.outline.hover};
  }

  ${radialEffect.active(button.background.outline.after)}

  &:after {
    color: ${button.text.outline.hover};
  }
`;
